import React, { memo } from "react";

const IconPen = ({ color = "#264D59", ...props }) => (
  <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M11.5 2.5L0.75 13.25V17.25H4.75L15.5 6.5M11.5 2.5L12.4216 1.57843C12.952 1.04799 13.6714 0.75 14.4216 0.75C15.9837 0.75 17.25 2.01633 17.25 3.57843C17.25 4.32857 16.952 5.04799 16.4216 5.57843L15.5 6.5M11.5 2.5L15.5 6.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(IconPen);
